import { createSelector } from "reselect";

import { definitionSelectors } from "../../modules/definition";
import { calendarSelectors } from "../../modules/definition/calendar";
import { propertySelectors } from "../../modules/definition/properties";
import { referenceSelectors } from "../../modules/definition/references";
import { typeSelectors } from "../../modules/definition/types";
import displayCacheSelectors from "../../modules/display/selectors";
import { itemSelectors } from "../../modules/items";
import { relationshipSelectors } from "../../modules/relationships";
import { superAndChildrenSelectors } from "../../modules/superAndChildrenById";
import { syncSelectors } from "../../modules/sync";
import { tagSelectors } from "../../modules/tags";
import syncRepresentationOfEntityFolders from "./syncRepresentationOfEntityFolders";

const syncRepresentationOfEntityFoldersFromStatusState = createSelector(
  // inputs
  displayCacheSelectors.getDisplayItemsById,
  superAndChildrenSelectors.getSuperAndChildrenById,
  typeSelectors.getTypesById,
  typeSelectors.getOrderedTypeIds,
  itemSelectors.getItemIdsInTreeOrderByTypeFromState,
  relationshipSelectors.getRelationshipsById,
  propertySelectors.getPropertiesById,
  referenceSelectors.getReferencesById,
  definitionSelectors.getColorMap,
  syncSelectors.getLocalToExternalIds,
  syncSelectors.getUpdatedSettingsOrSettings,
  tagSelectors.getTags,
  calendarSelectors.getCalendar,
  syncSelectors.getExternalSyncRep,

  // calculate based on inputs
  syncRepresentationOfEntityFolders
);

export default syncRepresentationOfEntityFoldersFromStatusState;
